import { defineRecipe } from '@chakra-ui/react';

export const spinnerRecipe = defineRecipe({
  base: {
    color: 'hmRed.400',
  },
});

export default spinnerRecipe;
